"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _line = require("cccisd-nivo/line");
var _util = require("./util.js");
var _style = _interopRequireDefault(require("./style.css"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _has2 = _interopRequireDefault(require("lodash/has"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GraphQLLineChart = function GraphQLLineChart(props) {
  var processData = function processData(seriesKeys) {
    var seriesType = props.seriesType;
    var seriesData = [];
    var series = {};
    if (seriesType === 'single') {
      series = processSingleSeries();
      seriesData.push(series);
    } else if (seriesType === 'subseries') {
      seriesKeys.forEach(function (key) {
        series = processSubSeries(key);
        seriesData.push(series);
      });
    } else {
      // seriesType === "independent"
      seriesKeys.forEach(function (key) {
        series = processIndependentSeries(key);
        seriesData.push(series);
      });
    }
    return seriesData;
  };
  var processSingleSeries = function processSingleSeries() {
    var seriesKey = props.seriesKey,
      reverseData = props.reverseData;
    var chartData = getSingleSeriesData(_objectSpread({}, props));
    if (reverseData) {
      chartData = chartData.reverse();
    }
    return {
      id: seriesKey,
      data: chartData
    };
  };
  var getSingleSeriesData = function getSingleSeriesData(_ref) {
    var data = _ref.data,
      xPath = _ref.xPath,
      yPath = _ref.yPath,
      xToYPathMap = _ref.xToYPathMap,
      valuePrecision = _ref.valuePrecision,
      maxLabelLength = _ref.maxLabelLength,
      labelTailLength = _ref.labelTailLength;
    var chartData = [];
    if (!(0, _isEmpty2["default"])(xToYPathMap)) {
      for (var _i = 0, _Object$keys = Object.keys(xToYPathMap); _i < _Object$keys.length; _i++) {
        var x = _Object$keys[_i];
        var y = (0, _util.setPrecision)((0, _util.dotIndex)(xToYPathMap[x], data), valuePrecision);
        chartData.push({
          x: x,
          y: y
        });
      }
    } else {
      chartData = data.map(function (row) {
        var x = (0, _util.shorten)((0, _util.dotIndex)(xPath, row), maxLabelLength, labelTailLength);
        if (typeof x === 'undefined') {
          return {
            x: null,
            y: null
          };
        }
        var y = (0, _util.setPrecision)((0, _util.dotIndex)(yPath, row), valuePrecision);
        return {
          x: x,
          y: y
        };
      });
    }
    return chartData;
  };
  var processSubSeries = function processSubSeries(key) {
    var data = props.data,
      seriesPath = props.seriesPath,
      xToSeriesPathMap = props.xToSeriesPathMap,
      xPath = props.xPath,
      reverseData = props.reverseData,
      maxLabelLength = props.maxLabelLength,
      labelTailLength = props.labelTailLength;
    var chartData = [];
    if (seriesPath === '') {
      if ((0, _isEmpty2["default"])(xToSeriesPathMap)) {
        console.error('Must specify seriesPath or xToSeriesPathMap');
      }
      for (var _i2 = 0, _Object$keys2 = Object.keys(xToSeriesPathMap); _i2 < _Object$keys2.length; _i2++) {
        var x = _Object$keys2[_i2];
        var seriesData = (0, _util.dotIndex)(xToSeriesPathMap[x], data);
        chartData.push(getSubSeriesData(_objectSpread(_objectSpread({}, props), {}, {
          x: x,
          key: key,
          seriesData: seriesData
        })));
      }
    } else {
      chartData = data.map(function (row) {
        var x = (0, _util.shorten)((0, _util.dotIndex)(xPath, row), maxLabelLength, labelTailLength);
        var seriesData = (0, _util.dotIndex)(seriesPath, row);
        return getSubSeriesData(_objectSpread(_objectSpread({}, props), {}, {
          x: x,
          key: key,
          seriesData: seriesData
        }));
      });
    }
    if (reverseData) {
      chartData = chartData.reverse();
    }
    return {
      id: key,
      data: chartData
    };
  };
  var getSubSeriesData = function getSubSeriesData(_ref2) {
    var data = _ref2.data,
      seriesKeyPath = _ref2.seriesKeyPath,
      seriesYPath = _ref2.seriesYPath,
      seriesToYPathMap = _ref2.seriesToYPathMap,
      x = _ref2.x,
      key = _ref2.key,
      valuePrecision = _ref2.valuePrecision,
      seriesData = _ref2.seriesData;
    var y = null;
    if (typeof x === 'undefined') {
      return {
        x: null,
        y: null
      };
    }
    if (seriesData === null) {
      return {
        x: x,
        y: null
      };
    }
    if (seriesYPath === '') {
      if ((0, _isEmpty2["default"])(seriesToYPathMap)) {
        console.error('Must specify seriesYPath or seriesToYPathMap');
      }
      if ((0, _has2["default"])(seriesToYPathMap, key)) {
        y = (0, _util.setPrecision)((0, _util.dotIndex)(seriesToYPathMap[key], seriesData), valuePrecision);
      }
      return {
        x: x,
        y: y
      };
    }
    var match = seriesData.filter(function (obj) {
      return (0, _util.dotIndex)(seriesKeyPath, obj) === key;
    });
    if (match.length < 1) {
      return {
        x: x,
        y: null
      };
    }
    y = (0, _util.setPrecision)((0, _util.dotIndex)(seriesYPath, match[0]), valuePrecision);
    return {
      x: x,
      y: y
    };
  };
  var processIndependentSeries = function processIndependentSeries(key) {
    var data = props.data,
      seriesKeyPath = props.seriesKeyPath,
      seriesDataPath = props.seriesDataPath,
      seriesToDataPathMap = props.seriesToDataPathMap,
      reverseData = props.reverseData;
    var chartData = [];
    var seriesData = [];
    if (seriesDataPath === '') {
      if ((0, _isEmpty2["default"])(seriesToDataPathMap)) {
        var match = data.filter(function (obj) {
          return (0, _util.dotIndex)(seriesKeyPath, obj) === key;
        });
        if (match.length > 0) {
          chartData = getSingleSeriesData(_objectSpread(_objectSpread({}, props), {}, {
            data: match[0]
          }));
        }
      } else if ((0, _has2["default"])(seriesToDataPathMap, key)) {
        seriesData = seriesToDataPathMap[key];
        chartData = getSingleSeriesData(_objectSpread(_objectSpread({}, props), {}, {
          data: seriesData
        }));
      }
    } else {
      var _match = data.filter(function (obj) {
        return (0, _util.dotIndex)(seriesKeyPath, obj) === key;
      });
      if (_match.length > 0) {
        seriesData = (0, _util.dotIndex)(seriesDataPath, _match[0]);
        chartData = getSingleSeriesData(_objectSpread(_objectSpread({}, props), {}, {
          data: seriesData
        }));
      }
    }
    if (reverseData) {
      chartData = chartData.reverse();
    }
    return {
      id: key,
      data: chartData
    };
  };
  var renderTotal = function renderTotal(chartData) {
    var totalLabel = props.totalLabel,
      showTotal = props.showTotal;
    var chartTotal = chartData.reduce(function (cume, series) {
      return cume + series.data.reduce((0, _util.totalReducer)('y'), 0);
    }, 0);
    if (!showTotal) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].total
    }, totalLabel, ":\xA0", chartTotal);
  };
  var renderLine = function renderLine(chartData) {
    var width = props.width,
      height = props.height,
      seriesType = props.seriesType,
      nivo = props.nivo;
    var wrapperProps = {
      width: width,
      height: height
    };
    var defaultProps = {
      margin: {
        top: 50,
        right: 80,
        bottom: 50,
        left: 100
      },
      colors: {
        scheme: 'category10'
      },
      animate: true,
      motionStiffness: 90,
      motionDamping: 15
    };
    if (seriesType === 'single') {
      defaultProps.legends = [];
    } else {
      defaultProps.margin = {
        top: 50,
        right: 150,
        bottom: 50,
        left: 120
      };
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: wrapperProps
    }, renderTotal(chartData), /*#__PURE__*/_react["default"].createElement(_line.ResponsiveLine, _extends({}, defaultProps, nivo, {
      data: chartData
    })));
  };
  var findSeriesKeys = function findSeriesKeys() {
    var data = props.data,
      seriesType = props.seriesType,
      seriesKey = props.seriesKey,
      seriesPath = props.seriesPath,
      xToSeriesPathMap = props.xToSeriesPathMap,
      seriesKeyPath = props.seriesKeyPath,
      seriesToDataPathMap = props.seriesToDataPathMap;
    if (seriesType === 'single') {
      return [seriesKey];
    }
    var keys = [];
    if (seriesType === 'subseries') {
      if (seriesPath === '') {
        if ((0, _isEmpty2["default"])(xToSeriesPathMap)) {
          console.error('Must specify seriesPath or xToSeriesPathMap');
        }
        for (var _i3 = 0, _Object$keys3 = Object.keys(xToSeriesPathMap); _i3 < _Object$keys3.length; _i3++) {
          var x = _Object$keys3[_i3];
          var seriesData = (0, _util.dotIndex)(xToSeriesPathMap[x], data);
          if (typeof seriesData !== 'undefined' && seriesData !== null) {
            seriesData.forEach(function (item) {
              var key = (0, _util.dotIndex)(seriesKeyPath, item);
              if (typeof key !== 'undefined' && !keys.includes(key)) {
                keys.push(key);
              }
            });
          }
        }
      } else {
        data.forEach(function (row) {
          var seriesData = (0, _util.dotIndex)(seriesPath, row);
          if (typeof seriesData !== 'undefined' && seriesData !== null) {
            seriesData.forEach(function (item) {
              var key = (0, _util.dotIndex)(seriesKeyPath, item);
              if (typeof key !== 'undefined' && !keys.includes(key)) {
                keys.push(key);
              }
            });
          }
        });
      }
    } else if (seriesType === 'independent') {
      if (seriesKeyPath === '') {
        if ((0, _isEmpty2["default"])(seriesToDataPathMap)) {
          console.error('Must specify seriesKeyPath or seriesToDataPathMap');
        }
        for (var _i4 = 0, _Object$keys4 = Object.keys(seriesToDataPathMap); _i4 < _Object$keys4.length; _i4++) {
          var key = _Object$keys4[_i4];
          if (typeof key !== 'undefined' && !keys.includes(key)) {
            keys.push(key);
          }
        }
      } else {
        data.forEach(function (item) {
          var key = (0, _util.dotIndex)(seriesKeyPath, item);
          if (typeof key !== 'undefined' && !keys.includes(key)) {
            keys.push(key);
          }
        });
      }
    }
    return keys;
  };
  var seriesKeys = findSeriesKeys();
  var chartData = processData(seriesKeys);
  if (chartData === null) {
    return null;
  }
  return renderLine(chartData, seriesKeys);
};
GraphQLLineChart.propTypes = {
  data: _propTypes["default"].array.isRequired,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  seriesType: _propTypes["default"].string,
  xPath: _propTypes["default"].string,
  yPath: _propTypes["default"].string,
  xToYPathMap: _propTypes["default"].object,
  seriesKey: _propTypes["default"].string,
  xToSeriesPathMap: _propTypes["default"].object,
  seriesPath: _propTypes["default"].string,
  seriesKeyPath: _propTypes["default"].string,
  seriesYPath: _propTypes["default"].string,
  seriesToYPathMap: _propTypes["default"].object,
  seriesDataPath: _propTypes["default"].string,
  seriesToDataPathMap: _propTypes["default"].object,
  valuePrecision: _propTypes["default"].number,
  maxLabelLength: _propTypes["default"].number,
  maxTailLength: _propTypes["default"].number,
  showTotal: _propTypes["default"].bool,
  totalLabel: _propTypes["default"].string,
  nivo: _propTypes["default"].object
};
GraphQLLineChart.defaultProps = {
  width: '100%',
  height: '600px',
  // Possible values: "single", "subseries", "independent"
  seriesType: 'single',
  // Relevant for "single":
  xPath: 'value',
  yPath: 'valueCount',
  xToYPathMap: {},
  seriesKey: 'data',
  // Relevant for "subseries":
  // xPath
  xToSeriesPathMap: {},
  seriesPath: '',
  seriesKeyPath: 'value',
  seriesYPath: 'valueCount',
  seriesToYPathMap: {},
  // Relevant for "independent":
  // seriesKeyPath
  seriesDataPath: '',
  seriesToDataPathMap: {},
  // xPath
  // yPath
  // xToYPathMap

  valuePrecision: 1,
  totalLabel: 'Total',
  showFrequencyTable: false,
  nivo: {}
};
var _default = exports["default"] = GraphQLLineChart;